import React, { useMemo, useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { IconDependencyTree } from '@contrast-security-inc/design-system-foundations'
import { SingleSelect } from '@contrast-security-inc/design-system-inputs'
import { Link } from '@contrast-security-inc/design-system-typography'
import { InformationPanel } from '@contrast-security-inc/design-system-surfaces'
import { ModuleApplication, ModulesResponse } from './interfaces'
import { getProjectsRoute } from '../../../../components/route'
import { SplitContext } from '../../../../ng/splitio-wrapper'

interface Props {
  mergedApplications: ModulesResponse | undefined
  setSelectedApplicationId: React.Dispatch<React.SetStateAction<string>>
  selectedApplicationId: string
  organizationID: string
}
export const MissingInformationPanel = ({
  organizationID,
  mergedApplications,
  setSelectedApplicationId,
  selectedApplicationId
}: Props) => {
  const { isSplitTreatmentOn } = useContext(SplitContext)
  const intl = useIntl()
  const applications = useMemo(
    () =>
      mergedApplications
        ? [
            mergedApplications.parentApplication,
            ...mergedApplications.applications
          ]
        : [],
    [mergedApplications]
  )
  const initialSelectedItem = useMemo(
    () => applications.find((app) => app.app_id === selectedApplicationId),
    [applications, selectedApplicationId]
  )
  const id = isSplitTreatmentOn('PROD-2340_SIR_Projects_Tab')
    ? 'detail_getCLI_projects'
    : 'detail_getCLI'

  return (
    <div
      className={css`
        display: flex;
        flex-direction: column;
      `}
    >
      {applications.length > 0 &&
        mergedApplications &&
        mergedApplications.applications.length > 0 && (
          <>
            <div
              className={css`
                display: flex;
                justify-content: flex-end;
                margin-bottom: 10px;
                input {
                  height: auto !important;
                }
              `}
            >
              <div
                className={css`
                  display: flex;
                  justify-content: center;
                  align-items: center;
                `}
              >
                <b
                  className={css`
                    margin-right: 10px;
                  `}
                >
                  <FormattedMessage id="title_application" /> :
                </b>
              </div>
              <SingleSelect<ModuleApplication>
                value={initialSelectedItem}
                items={applications}
                onChange={(_, application) => {
                  if (application) {
                    setSelectedApplicationId(application.app_id)
                  }
                }}
                itemToString={(application) => {
                  return application.name
                }}
                itemToID={(application) => application.app_id}
                style={{
                  backgroundColor: 'white',
                  paddingTop: 0,
                  width: 300
                }}
                allowItemTextWrap
                className={css`
                  button:first-of-type {
                    display: none !important;
                  }
                `}
                testId="select-application"
              />
            </div>
          </>
        )}
      <InformationPanel
        testId="missing-information-panel"
        Icon={IconDependencyTree}
        title={
          intl.formatMessage(
            { id: 'detail_missingValuableInformation' },
            { b: (...msg) => <b>{msg}</b> }
          ) as string
        }
        subtitle={intl.formatMessage(
          { id },
          {
            a1: (...msg) => (
              <Link
                href="https://docs.contrastsecurity.com/en/install-contrast-cli.html"
                isExternal={true}
              >
                {msg}
              </Link>
            ),
            a2: (...msg) => (
              <Link href={getProjectsRoute(organizationID)} isExternal={true}>
                {msg}
              </Link>
            )
          }
        )}
      />
    </div>
  )
}
